import React, { FC }                  from 'react';
import styled                         from 'styled-components';
import {
  TDataTableRow,
  ISearchInputValues,
}                                     from '@typings/components';
import { DataTable }                  from '@components/DataTable/DataTable';
import { SearchInput }                from '@components/SearchInput/SearchInput';
import { SearchPagination }           from '@components/SearchPagination/SearchPagination';
import { BIDDER_USERS_TABLE_HEADERS } from '../utils/tableHeaders';

interface IProps {
  tableRows        : TDataTableRow[];
  isLoading        : boolean;
  totalUsersCount  : number;
  currentPage      : number;
  rowsPerPage      : number;
  inputValue       : string;
  handleSearch     : (values: ISearchInputValues) => void;
  handleChangePage : (page: number) => void;
}

const Wrapper = styled.div`
  max-width : 1280px;
  margin    : 0 auto;
`;

export const BiddersListPage: FC<IProps> = ({
  tableRows,
  totalUsersCount,
  isLoading,
  currentPage,
  rowsPerPage,
  inputValue,
  handleSearch,
  handleChangePage,
}) => (
  <Wrapper>
    <SearchInput
      initialValue = {inputValue}
      handleSearch = {handleSearch}
      placeholder  = "Search by User’s Name"
      maxWidth     = "700px"
      margin       = "20px 0 40px"
    />

    <DataTable
      headers  = {BIDDER_USERS_TABLE_HEADERS}
      rows     = {tableRows}
      maxwidth = "1024px"
      loading  = {isLoading}
    />

    {!!totalUsersCount && (
      <SearchPagination
        totalItems       = {totalUsersCount}
        currentPage      = {currentPage}
        rowsPerPage      = {rowsPerPage}
        handleChangePage = {handleChangePage}
        maxWidth         = "1024px"
      />
    )}
  </Wrapper>
);
